    <div class="row mt-2">
        <div class="col-md-12">
            <div class="py-3 pl-3 mb-2">
                <h4 class="heading-4"><span class="color-grey-700">{{title}}</span></h4>
            </div>
            <div class="row srow" 
                infiniteScroll
                [infiniteScrollDistance]="1"
                [infiniteScrollThrottle]="1000"
                (scrolled)="onScroll()"
                [scrollWindow]="true">
                <div class="col-md-4 pr-1" *ngFor="let docTalkObj of list let idx=index">
                    <div class="mb-3 mr-3">
                        <app-hcf-template
                            [callingfrom]="'viewAllDoc'"
                            [horizontal]="true"
                            [template]="4"
                            [templateInfo]="docTalkObj.info"
                            [productCount]="list.length"
                            [playTime]="hcfPlayTime(docTalkObj?.info?.time?.total)"
                            [viewAll]="true"
                            (emitCardTarget)="cardTarget($event, docTalkObj)">
                        </app-hcf-template>
                    </div>
                </div>
            </div>
        </div>
    </div>